import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Cookies from "universal-cookie/cjs";
import { useMobileFirebaseProviderContext } from '../../mobileAppCore/providers/MobileFirebaseProvider/MobileFirebaseProviderContext';
import { getUserUidSelector } from '../../app/appSelectors';

const cookies = new Cookies();

function ExponeaProvider() {
    const { firebaseToken } = useMobileFirebaseProviderContext();
    const uid = useSelector(getUserUidSelector);

    useEffect(() => {
        if (uid) {
            const customerIdentifier: {
                uid: number,
                google_push_notification_id?: string,
            } = { uid };
            const properties: {
                app_id?: string,
                google_push_notification_id?: string,
            } = {};

            const app_id = cookies.get('app_id') || '';
            if (firebaseToken) {
                customerIdentifier['google_push_notification_id'] = firebaseToken;
                properties['google_push_notification_id'] = firebaseToken;
            }
            if (app_id) {
                properties.app_id = app_id;
            }
            window.exponea.identify(customerIdentifier, properties);
            if (firebaseToken) {
                window.exponea.track('push_subscription', {
                    action: 'accept',
                    google_push_notification_id: firebaseToken,
                    os: 'android',
                    type: 'mobile',
                    app_id,
                });
            }
        }
    }, [uid, firebaseToken]);

    return null;
}

export default ExponeaProvider;
